import { useMemo } from "preact/hooks";
import { useTranslation } from "react-i18next";
import styles from "./FixSearch.module.scss";
import { Input } from "@/uikit";
import { Icon } from "@/elements-react/fix-icon";
import { LayoutStyleTypes } from "@/util-react/layout";
import { testid } from "@fixparts/testid/index";
import { PageTags } from "../document-elements/page-tags";
import {useSearchCommon} from "@/elements-react/fix-search/search.common.ts";

export interface FixSearchProps {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
}

export const FixSearch = ({ type = LayoutStyleTypes.TYPE_LG }: FixSearchProps) => {
  const { t } = useTranslation();
  const { searchValue, handleChange, handleKeyDown, handleBlur, search, jsonLdDataset } = useSearchCommon();
  const iconSlot = useMemo(() => (type === LayoutStyleTypes.TYPE_LG ? "suffix" : "prefix"), [type]);

  return (
    <>
      <Input
        name="mpn-search"
        placeholder={t("kmaqihq7zxarr34z.search-placeholder", "Search for part number")}
        value={searchValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        onIconClick={search}
        icon={<Icon width={24} name="search" {...testid({ elm: "searchBtn" })} />}
        iconPosition={iconSlot}
        inputSize="medium"
        className={styles.search}
        {...testid({ elm: "searchInput" })}
      />
      <PageTags jsonld={jsonLdDataset} />
    </>
  );
};
